import { useLocalizedHref } from "@/libraries/web-framework";

export const ConfluenceFreePage = () => {
    const signupPath = useLocalizedHref("/try/cloud/signup");
    location.href = `${signupPath}?bundle=confluence&edition=free`;
    return null;
};
